webpackJsonp([231041097001941],{

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(79);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement('html', { lang: 'en' }),
	            _react2.default.createElement(
	                'title',
	                null,
	                'Privacy Policy of the CPM-CA.org'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 1170, padding: '20px', margin: 'auto' } },
	            _react2.default.createElement(
	                'h1',
	                null,
	                'Privacy Policy'
	            ),
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Terms of use and confidentiality'
	            ),
	            _react2.default.createElement(
	                'h5',
	                null,
	                'This form is intended for adults domiciled in Canada with or without insurance.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    '1. Emergency'
	                ),
	                _react2.default.createElement('br', null),
	                'In case of emergency, we recommend that you call your doctor or local emergency department immediately.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    '2. Processing requests'
	                ),
	                _react2.default.createElement('br', null),
	                'The appointment request is received by the Admissions Department of the CPM ( Psychotraumatology and Mediation Centre), which will contact you to propose a consultation date or, if necessary, ask you for additional information.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    '3. Waiting Periods'
	                ),
	                _react2.default.createElement('br', null),
	                'You will be contacted within 1 working day to receive an appointment proposal or, if necessary, to provide the service concerned with additional information. If you are not reachable within this time, we will try to contact you again for up to 5 business days. We invite you to contact us if we do not contact you within this time.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    '4. Incomplete Applications'
	                ),
	                _react2.default.createElement('br', null),
	                'The CPM reserves the right not to respond to any incomplete request.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    '5. Personal contact details'
	                ),
	                _react2.default.createElement('br', null),
	                'You will be contacted directly by telephone during office hours (9AM - 12PM & 1PM - 5PM) or by e-mail using the contact details you have provided. If you cancel or reschedule your first appointment with less than 48 hours notice, or if you do not show up, you will be charged the full amount of the consultation.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    '5. Confidentiality'
	                ),
	                _react2.default.createElement('br', null),
	                'By sending your contact details (telephone, e-mail, postal address), you authorise the CPM to send you, at these details, confidential information concerning your appointment request. We draw your attention to the fact that unauthorized persons, especially those around you, do not have access to these coordinates. The CPM cannot be held responsible if confidential information communicated by means of your personal contact details should be seen by unauthorised persons.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    '6. Data protection'
	                ),
	                _react2.default.createElement('br', null),
	                'The protection of the privacy of patients whose personal data are processed within our institution is a legal obligation. Federal and cantonal legislation on medical confidentiality and data protection obliges us to protect personal data against misuse. The CPM shall take all necessary measures to avoid unlawful processing of patient data.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'I hereby confirm that I have read and understood the above terms of use.'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'I agree to take the necessary measures to prevent unauthorized persons from having access to the information that the Psy-Scan Institute will transmit to me by means of my personal contact details.'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'The CPM cannot be held liable in the event of non-compliance by the applicant with the above rules of use.'
	                )
	            )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-en-privacy-policy-js-1ae2c9c6dcfa5aa9546b.js